import React from 'react';
import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';

export const AppToastContainer: React.FC = () => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <ToastContainer
      position="top-right"
      autoClose={4200}
      closeOnClick
      pauseOnHover
      draggable
      className="app-toast-container"
      toastClassName="app-toast"
      progressClassName="app-toast-progress"
    />,
    document.body
  );
};
